import { C as CosmosIconInProgress$1, d as defineCustomElement$1 } from './p-DaZNHDag.js';

const CosmosIconInProgress = CosmosIconInProgress$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInProgress, defineCustomElement };
